import { type FunctionComponent, type HTMLAttributes } from 'react';
import { type ShopByLookFieldsFragment } from '../../../../__generated__/graphql-client-types';
import { useClientOnlyBreakpoints } from '../../../../hooks/breakpoints/client-only-breakpoints.hook';
import { HomeShopByLookLarge } from './shop-by-look-large.component';
import { HomeShopByLookSmall } from './shop-by-look-small.component';

const NEW_SHOP_BY_LOOK_STYLES = 'flex flex-row flex-wrap flex-nowrap-l bg-theme-primary-dark w-100 h-100';

export type HomeShopByLookProps = ShopByLookFieldsFragment & Pick<HTMLAttributes<HTMLElement>, 'className'>;

export const HomeShopByLook: FunctionComponent<HomeShopByLookProps> = ({
	className = 'flex flex-column items-center w-100 h-100',
	...props
}) => {
	const { isLarge } = useClientOnlyBreakpoints();

	return (
		<section className={className}>
			{isLarge ? (
				<HomeShopByLookLarge {...props} className={NEW_SHOP_BY_LOOK_STYLES} />
			) : (
				<HomeShopByLookSmall {...props} className={NEW_SHOP_BY_LOOK_STYLES} />
			)}
		</section>
	);
};
